'use strict';

import angular from "angular";
import { times } from "lodash";

function dateStringToDate(date) {
  var split = date.split('/');
  var year = +split[2]; //make integer
  if(year < 100){
    year += 2000;
  }
  var month = +split[1] - 1; //make integer and zero indexed
  var day = +split[0]; //make integer
  return new Date(year, month, day);
}

function dateToDateString(value){
  var result = new Date(value);
  var dd = result.getDate();
  var mm = result.getMonth() + 1; //January is 0

  var yyyy = result.getFullYear();

  var today = dd + '/' + mm + '/' + yyyy;
  return today;
};

export default class{
	/*@ngInject*/
	constructor($http, JSONToCSVConvertor, StringToCSV){
		this.$http = $http;
		this.tutors = [];
		this.students = [];
		this.timesheets = [];
		this.loadData();
		this.JSONToCSVConvertor = JSONToCSVConvertor;
		this.StringToCSV = StringToCSV;
	}

	processAll(){
		if(confirm('Are you sure you want to mark all timesheets as processed?')){
			this.$http.post('/api/timesheets/process').then(res => {
				console.log('Done...')
				this.loadData();
			});
		}
	}

	showMYOB(){
		const tutors = this.timesheets.map(timesheet => timesheet.tutorID);
		this.$http.post('/api/timesheets/myob', {tutors}).then(res => {
			var tutors = res.data;

			console.log(tutors);

			if(tutors.length === 0){
				return alert('No tutors to be added to MYOB.');
			};

			tutors = tutors.map(tutorID => {
				return this.tutors.find(tutor => tutor.tutorID === tutorID);
			});

			this.JSONToCSVConvertor(tutors, 'MYOB-Tutors', true);
		})
		

	}

	writeCRM(){
		var day = String(this.date.getDate());
		var month = String(this.date.getMonth() + 1);
		var year = String(this.date.getFullYear());
		day = day.indexOf(0) === '0' ? day.substring(1): day;
		month = month.indexOf(0) === '0' ? month.substring(1): month;
		var weekEnding = day + '/' + month + '/' + year;
		var students = {};
		var tutors = {};
		this.timesheets.forEach(timesheet => {
			if (!(timesheet.studentID in students) && timesheet.studentID) {
				students[timesheet.studentID] = {};
				students[timesheet.studentID]['hours'] = 0;
			}
			if (!(timesheet.tutorID in tutors) && timesheet.tutorID) {
				tutors[timesheet.tutorID] = {}
				tutors[timesheet.tutorID]['hours'] = 0;
			}
		});
		this.$http.post('api/timesheets/multiple-tutor-ids', { ids: Object.keys(tutors) })
		.then(res => {
			console.log(res.data.length);
			if (res.data.length > 0) {
				res.data.forEach(timesheet => {
					if (dateStringToDate(timesheet.weekEnding) <= this.date) {
						tutors[timesheet.tutorID]['tutor'] = this.tutors.find(tutor => tutor.tutorID === timesheet.tutorID);
						tutors[timesheet.tutorID]['hours'] += timesheet.hours;
					}
				});
				console.log(Object.values(tutors).length)
				this.$http.post('api/students/write-crm', { tutors: Object.values(tutors) })
				.then(res => {
					console.log(res);
				}) 

			}
		})
		this.$http.post('api/timesheets/multiple-student-ids', { ids: Object.keys(students) })
		.then(res => {
			if (res.data.length > 0) {
				res.data.forEach(timesheet => {
					if (dateStringToDate(timesheet.weekEnding) <= this.date) {
						students[timesheet.studentID]['student'] = this.students.find(student => student.studentID === timesheet.studentID);
						students[timesheet.studentID]['hours'] += timesheet.hours;
						// if (!(timesheet.tutorID in tutors)) {
						// 	tutors[timesheet.tutorID] = {}
						// 	tutors[timesheet.tutorID]['hours'] = 0;
						// }
						// tutors[timesheet.tutorID]['tutor'] = this.tutors.find(tutor => tutor.tutorID === timesheet.tutorID);
						// tutors[timesheet.tutorID]['hours'] += timesheet.hours;
					}
				});
				console.log(Object.values(students).length);
				this.$http.post('api/students/write-crm', { students: Object.values(students) })
				.then(res => {
					console.log(res);
				}) 
				alert("Write to CRM successfully");
			} else {
				alert('There are no unprocessed students in ' + weekEnding);
			}
		})

	}

	tutorName(tutorID){
		const tutor = this.tutors.find(tutor => tutor.tutorID === tutorID);
		if(!tutor){
			return
		}
		return tutor.nameFirst + ' ' + tutor.nameLast;
	}

	studentName(studentID){
		const student = this.students.find(student => student.studentID === studentID);
		if(!student){
			return
		}
		return student.nameFirst + ' ' + student.nameLast;
	}

	generateCSV(){
		//filter out processed
		let unprocessed = JSON.parse(angular.toJson(this.timesheets.filter(timesheet => timesheet.isProcessed !== true)));
		if(unprocessed.length === 0){
			return alert('There are no timesheets to be processed.');
		}

		var lines = {}; //lines will be an array of objects

		unprocessed.forEach(timesheet => {
			if (!lines[timesheet.tutorID + timesheet.rateType]) {
				lines[timesheet.tutorID + timesheet.rateType] = timesheet;
			} else {
				lines[timesheet.tutorID + timesheet.rateType].hours = lines[timesheet.tutorID + timesheet.rateType].hours + timesheet.hours;
			}
		});
		
		//add additional information
		var new_lines = [];
		Object.keys(lines).map(id => {
			var tutorID = parseInt(id.slice(0, -1));
			const tutor = this.tutors.find(tutor => tutor.tutorID === tutorID);
			
			if (tutor) {
				var timesheet = lines[id];
				timesheet.invoiceCode = tutor.invoiceCode;
				timesheet.firstName = tutor.nameFirst;
				timesheet.lastName = tutor.nameLast;
				timesheet.crmID = tutor.crmID;
				new_lines.push(timesheet);
			}
		});

		// sort data by lastname
		new_lines = new_lines.sort((a,b) => {
			const nameA = a.lastName.toUpperCase();
			const nameB = b.lastName.toUpperCase();

			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

			// names must be equal
			return 0;
		});

		// //sort data by firstname
		new_lines = new_lines.sort((a,b) => {
			const nameA = a.firstName.toUpperCase();
			const nameB = b.firstName.toUpperCase();

			if (nameA < nameB) {
				return -1;
			}
			if (nameA > nameB) {
				return 1;
			}

		// 	// names must be equal
			return 0;
		});

		// //remove two days from the line date

		new_lines = new_lines.map(line => {
			
			if(line){
				var lineDate = dateStringToDate(line.weekEnding);

				lineDate.setDate(lineDate.getDate() - 2)
	
				line.weekEnding = dateToDateString(lineDate);
	
				return line;
			}		
		})

		const day = String(this.date.getDate());
		const month = String(this.date.getMonth() + 1);
		const year = String(this.date.getFullYear());
		const date = day + '-' + month + '-' + year;
		const filename = 'Timesheet-' + date;


		// //new process starts here

		var headers = ['"Employee Co Last Name","Employee First Name","Payroll Category","Job","Customer Co Last Name","Customer First Name","Notes","Date","Units","Employee Card ID","Employee Record ID","Start/Stop Time","Customer Card ID","Customer Record ID"'];

		new_lines.forEach(record => {
			if(record){
				var hourly;

				if(record.rateType === 'B'){
					hourly = 'Base Hourly';
				} else {
					hourly = 'In-Home Tuition';
				}

				var additionalLine = `"${record.lastName}","${record.firstName}","${hourly}","","","","","${record.weekEnding}",${record.hours},"${record.crmID || ''}","","","",""`;

				headers.push(additionalLine);
			}
		});
		const fullString = headers.join('\n');
		this.StringToCSV(fullString, filename);
		// this.$http.post('/api/timesheets/send-email', {data: fullString, filename});
	}

	loadData(){
		console.log('Loading data...');

	    this.$http.get('/api/students').then(res => {
	    	this.students = res.data;
	    })

	    this.$http.get('/api/tutors').then(res => {
	    	this.tutors = res.data;
	    })

	    this.$http.get('/api/timesheets/unprocessed').then(res => {
	    	this.timesheets = res.data;
	    })
  	}
}


// WEBPACK FOOTER //
// ./client/app/process/process.controller.js